import React from 'react';
import VideoPlayer from './PlayerContainer';

import { ASSETS_SERVER_PATH } from '../../config/defaults';

//import Server from '../../services/Server';

import I18n from '../../locales/i18n';

import { Container as MessageContainer } from '../../screens/ViewerZone/Countdown/Styles';

class PlayerSelector extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isAlive: true,
		};

		this.interval = null;
	}

	componentDidMount() {
		this.getEncoderStatus();
	}
	getEncoderStatus = () => {
		/*
		const { eventId = '_', stream ={}} = this.props;
		const { id = '_', server = '_'} = stream;
		const self = this;

		Server.events.getStreamStatus(server, id, eventId)
		.then((ans)=>{
			const 
				{ data = {}} = ans.data,
				{ isConnected = false}= data;

			self.setState({
				isAlive: isConnected
			}, ()=>{
				setTimeout(self.getEncoderStatus, 30000);				
			});

		})
		.catch((error)=>{
			setTimeout(self.getEncoderStatus, 5000);
		})*/
	};
	render() {
		if (this.props.type === 'youtube') {
			return <VideoPlayer {...this.props} />;
		}

		if (!this.state.isAlive) {
			return (
				<MessageContainer>
					<h2>{I18n('VIEWER_ZONE', 'NO_ENCODER_CONNECTED')}</h2>
				</MessageContainer>
			);
		}

		return (
			<iframe
				title={this.props.title}
				style={this.props.style}
				allowFullScreen={true}
				width="100%"
				scrolling="no"
				onLoad={this.props.onLoad}
				frameBorder="0"
				src={`${ASSETS_SERVER_PATH}events/${this.props.eventId}/player.html${this.props.params}`}
			></iframe>
		);
	}
}

export default PlayerSelector;
